import React from 'react';
import { generateBreadCrumbsForDetailsPage } from 'core/utils/breadCrumbsGenerator';
import { Box, Breadcrumb } from '@drone-js/core';
import { connect } from 'react-redux';
import { BreadcrumbStateProps, mapStateToProps } from 'component/page/detail/DetailCard/Breadcrumb/Breacrumb.selectors';

const BreadcrumbsNodeComponent: React.FC<BreadcrumbStateProps> = (props) => {
    const breadcrumbs = generateBreadCrumbsForDetailsPage(props.cms, props.activityId, props.categoryId, props.title);
    const hasBreadcrumbs = breadcrumbs && breadcrumbs.length > 0;
    if (!hasBreadcrumbs) {
        return null;
    }

    return (
        <Box mb="16" mt={props.isPageContainerSpacing ? undefined : '16'}>
            <Breadcrumb data-testid="details-breadcrumbs" contents={breadcrumbs} />
        </Box>
    );
};
BreadcrumbsNodeComponent.displayName = 'BreadcrumbsNodeComponent';
export default connect(mapStateToProps)(BreadcrumbsNodeComponent);
